module.exports = __webpack_public_path__ + "img/messager.c7b75e83.png";